import store from '~/javascripts/store.js';

export default ($el) => {
  if (window.isMobile) {
    $el.data('disabled', 'true');
  }

  $el.on('click', (e) => {
    e.preventDefault();

    if (
      ['donate', 'donation', 'give today'].includes($el.text().toLowerCase())
    ) {
      store.donateForm.isSubscription = false;
    } else {
      store.donateForm.isSubscription = true;
    }

    if ($('.mobile-donate-banner .button:visible').length !== 0) {
      $('.mobile-donate-banner > div > .button').click();
    }
  });
};
